<template lang="pug">
  li.sale-theme-item
    div.product-thumbnail
      div.new-bradge
        span  New
      img(src="https://www.stance.com/dw/image/v2/BBBN_PRD/on/demandware.static/-/Sites-masterCatalog_Stance/default/dw66273589/prod_images/M556D18ITS_WHT.jpg?sw=320&sh=480&sm=fit")
    div.product-information
      p.name ITS SNOW LIT
      p.attribute Classic Crew
      p.price CNY 83.30
</template>

<script>
export default {
  name: 'SaleThemeItem'
}
</script>

<style lang="scss" scoped>
@import "../assets/common.scss";
.product-thumbnail {
  position: relative;
  height: 50vw;
  img {
    max-width: 100%;
    width: auto;
    height: auto;
    backface-visibility: hidden;
    transition: opacity .5s ease-in-out;
    height: 100%;
    object-fit: contain;
    background: #fff;
  }
  .new-bradge {
    position: absolute;
    top: .5rem;
    left: .5rem;
    width: 2.5rem;
    height: 2.5rem;
    z-index: 1;
  }
  .new-bradge span {
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    font-size: 10px;
    font-size: .625rem;
    line-height: 2.5rem;
    font-family: akzidenz-grotesk,Arial,sans-serif;
    font-weight: 500;
    background: $blackColor;
    color:#fff;
    text-align: center;
  }
}

.product-information {
  padding-top: .625rem;
  border-top: 1px solid #e7e7ef;
  p {
    margin :0;
  }
  .name {
    font-family: akzidenz-grotesk-condensed,Arial Narrow,Arial,sans-serif;
    font-weight: 400;
    text-transform: uppercase;
    font-size: 20px;
    font-size: 1.25rem;
  }
  .attribute {
    padding-top: .3125rem;
    font-size: 12px;
    font-size: .75rem;
  }

  .price {
    font-family: akzidenz-grotesk,Arial,sans-serif;
    font-weight: 500;
    font-size: 14px;
    font-size: .875rem;
    color: #1a1a1a;
    margin-top: .625rem;
    margin-bottom: .625rem;
  }
}

@media only screen and (min-width: 768px) {
  .product-thumbnail {
    height: 18rem;
  }
}
</style>
